import { getCurrentStay } from "../models/profile/profile.model";
import { COMMON_PREFERENCE_TYPES } from "../models/profile/preference.model";
import { uniq } from "lodash";
import { ReservationStatus } from "../models/reservation/reservation.model";
import { convertLocalDateToDate, formatFullDMY } from "./date.util";
import { defaultCountries, getActiveFormattingMask, guessCountryByPartialPhoneNumber } from "react-international-phone";
export var formatProfileListName = function (profile) { return [
    profile === null || profile === void 0 ? void 0 : profile.lastName,
    profile === null || profile === void 0 ? void 0 : profile.firstName,
    profile === null || profile === void 0 ? void 0 : profile.namePrefix,
    profile === null || profile === void 0 ? void 0 : profile.academicTitle,
]
    .map(function (value) { return value === null || value === void 0 ? void 0 : value.trim(); })
    .filter(function (value) { return Boolean(value); })
    .join(" "); };
// Mirrors ProfileV3.primaryEmail() on the backend: the address flagged primary, else the first one.
// emails[0] is usually the PMS-synced address, which staff cannot edit or delete.
export var getPrimaryEmail = function (profile) { var _a, _b, _c, _d; return (_d = ((_b = (_a = profile === null || profile === void 0 ? void 0 : profile.emails) === null || _a === void 0 ? void 0 : _a.find(function (e) { return e.isPrimary && !!e.email; })) !== null && _b !== void 0 ? _b : (_c = profile === null || profile === void 0 ? void 0 : profile.emails) === null || _c === void 0 ? void 0 : _c.find(function (e) { return !!e.email; }))) === null || _d === void 0 ? void 0 : _d.email; };
// Now returning preferences -> as we need to conditionally show newly added preferences from voice note
export var getProfileAllergies = function (profile, onlyFromFullData) {
    var _a, _b;
    if ((_a = profile === null || profile === void 0 ? void 0 : profile.preferences) === null || _a === void 0 ? void 0 : _a.length) {
        return ((_b = profile === null || profile === void 0 ? void 0 : profile.preferences) === null || _b === void 0 ? void 0 : _b.filter(function (p) { return p.preferenceType === COMMON_PREFERENCE_TYPES.CRQLAR_FOOD_ALLERGY && !!p.preferenceValue; })) || [];
    }
    return [];
};
export var getProfileAllergiesString = function (profile, onlyFromFullData) {
    var _a, _b;
    if ((_a = profile === null || profile === void 0 ? void 0 : profile.preferences) === null || _a === void 0 ? void 0 : _a.length) {
        return ((_b = profile === null || profile === void 0 ? void 0 : profile.preferences) === null || _b === void 0 ? void 0 : _b.filter(function (p) { return p.preferenceType === COMMON_PREFERENCE_TYPES.CRQLAR_FOOD_ALLERGY && !!p.preferenceValue; }).map(function (preference) { return preference.preferenceValue; })) || [];
    }
    return [];
};
// Created new function to get food diets as Preference objects
// Preferences contain valuable info about the voice note id
export var getProfileFoodDiets = function (profile, onlyFromFullData) {
    var _a, _b;
    if ((_a = profile === null || profile === void 0 ? void 0 : profile.preferences) === null || _a === void 0 ? void 0 : _a.length) {
        return ((_b = profile === null || profile === void 0 ? void 0 : profile.preferences) === null || _b === void 0 ? void 0 : _b.filter(function (p) { return p.preferenceType === COMMON_PREFERENCE_TYPES.CRQLAR_FOOD_TYPE && !!p.preferenceValue; })) || [];
    }
    return [];
};
export var getProfileFoodDietsString = function (profile, onlyFromFullData) {
    var _a, _b;
    if ((_a = profile === null || profile === void 0 ? void 0 : profile.preferences) === null || _a === void 0 ? void 0 : _a.length) {
        return ((_b = profile === null || profile === void 0 ? void 0 : profile.preferences) === null || _b === void 0 ? void 0 : _b.filter(function (p) { return p.preferenceType === COMMON_PREFERENCE_TYPES.CRQLAR_FOOD_TYPE && !!p.preferenceValue; }).map(function (preference) { return preference.preferenceValue; })) || [];
    }
    return [];
};
export var getProfileMedicalString = function (profile, onlyFromFullData) {
    var _a, _b;
    if ((_a = profile === null || profile === void 0 ? void 0 : profile.preferences) === null || _a === void 0 ? void 0 : _a.length) {
        return uniq(((_b = profile === null || profile === void 0 ? void 0 : profile.preferences) === null || _b === void 0 ? void 0 : _b.filter(function (p) { return p.preferenceType === COMMON_PREFERENCE_TYPES.CRQLAR_MEDICAL && !!p.preferenceValue; }).map(function (preference) { return preference.preferenceValue; })) || []);
    }
    return [];
};
export var getProfileMedical = function (profile, onlyFromFullData) {
    var _a, _b;
    if ((_a = profile === null || profile === void 0 ? void 0 : profile.preferences) === null || _a === void 0 ? void 0 : _a.length) {
        return uniq(((_b = profile === null || profile === void 0 ? void 0 : profile.preferences) === null || _b === void 0 ? void 0 : _b.filter(function (p) { return p.preferenceType === COMMON_PREFERENCE_TYPES.CRQLAR_MEDICAL && !!p.preferenceValue; })) || []);
    }
    return [];
};
// Now returning preferences -> as we need to conditionally show newly added preferences from voice note
export var getProfileInterests = function (profile, onlyFromFullData) {
    var _a, _b;
    if ((_a = profile === null || profile === void 0 ? void 0 : profile.preferences) === null || _a === void 0 ? void 0 : _a.length) {
        return uniq(((_b = profile === null || profile === void 0 ? void 0 : profile.preferences) === null || _b === void 0 ? void 0 : _b.filter(function (p) { return (
        // Include both CRQLAR_INTERESTS and CRQLAR_AI_GENERATED_INTERESTS
        p.preferenceType === COMMON_PREFERENCE_TYPES.CRQLAR_INTERESTS || p.preferenceType === COMMON_PREFERENCE_TYPES.CRQLAR_AI_GENERATED_INTERESTS) && !!p.preferenceValue; })) || []);
    }
    return [];
};
export var getProfileFullName = function (profile, forceLastName, defaultValue, withVIPCode) {
    var _a, _b, _c, _d;
    var parts = [];
    if ((_a = profile === null || profile === void 0 ? void 0 : profile.academicTitle) === null || _a === void 0 ? void 0 : _a.trim()) {
        parts.push((_b = profile === null || profile === void 0 ? void 0 : profile.academicTitle) === null || _b === void 0 ? void 0 : _b.trim());
    }
    else if ((_c = profile === null || profile === void 0 ? void 0 : profile.namePrefix) === null || _c === void 0 ? void 0 : _c.trim()) {
        parts.push((_d = profile === null || profile === void 0 ? void 0 : profile.namePrefix) === null || _d === void 0 ? void 0 : _d.trim());
    }
    if (forceLastName) {
        parts.push(profile === null || profile === void 0 ? void 0 : profile.lastName, profile === null || profile === void 0 ? void 0 : profile.firstName);
    }
    else {
        parts.push(profile === null || profile === void 0 ? void 0 : profile.firstName, profile === null || profile === void 0 ? void 0 : profile.lastName);
    }
    if (withVIPCode && (profile === null || profile === void 0 ? void 0 : profile.vipCode)) {
        parts.push("*".concat(profile.vipCode));
    }
    return parts.filter(Boolean).join(' ').trim() || defaultValue;
};
export var getProfileFullNameReversed = function (profile, defaultValue) {
    var _a, _b, _c, _d;
    var parts = [];
    parts.push(profile === null || profile === void 0 ? void 0 : profile.lastName, profile === null || profile === void 0 ? void 0 : profile.firstName);
    if ((_a = profile === null || profile === void 0 ? void 0 : profile.academicTitle) === null || _a === void 0 ? void 0 : _a.trim()) {
        parts.push((_b = profile === null || profile === void 0 ? void 0 : profile.academicTitle) === null || _b === void 0 ? void 0 : _b.trim());
    }
    else if ((_c = profile === null || profile === void 0 ? void 0 : profile.namePrefix) === null || _c === void 0 ? void 0 : _c.trim()) {
        parts.push((_d = profile === null || profile === void 0 ? void 0 : profile.namePrefix) === null || _d === void 0 ? void 0 : _d.trim());
    }
    return parts.filter(Boolean).join(' ').trim() || defaultValue;
};
export var formatProfileQuickInfo = function (profile, options) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var fullName = (options === null || options === void 0 ? void 0 : options.profileNameReversed) ?
        getProfileFullNameReversed(profile, '') :
        getProfileFullName(profile, true, '', options === null || options === void 0 ? void 0 : options.withVIP);
    var roomNumber = (_a = getCurrentStay(profile)) === null || _a === void 0 ? void 0 : _a.roomId;
    var rateCode = (_c = (_b = getCurrentStay(profile)) === null || _b === void 0 ? void 0 : _b.rateCode) === null || _c === void 0 ? void 0 : _c.substring(0, 4);
    var status = (_d = getCurrentStay(profile)) === null || _d === void 0 ? void 0 : _d.status;
    var parts = [];
    if ((options === null || options === void 0 ? void 0 : options.withRoom) && roomNumber) {
        parts.push(roomNumber);
    }
    // Showing gender only if permitted by the guest
    if ((options === null || options === void 0 ? void 0 : options.withGender) && (profile === null || profile === void 0 ? void 0 : profile.gender) && (profile === null || profile === void 0 ? void 0 : profile.genderNoShare) === false) {
        parts.push(options === null || options === void 0 ? void 0 : options.genderValue);
    }
    if ((options === null || options === void 0 ? void 0 : options.withEmail) && ((_e = profile === null || profile === void 0 ? void 0 : profile.emails) === null || _e === void 0 ? void 0 : _e.length)) {
        parts.push(getPrimaryEmail(profile));
    }
    if ((options === null || options === void 0 ? void 0 : options.withPhone) && ((_f = profile === null || profile === void 0 ? void 0 : profile.phones) === null || _f === void 0 ? void 0 : _f.length)) {
        parts.push((_g = profile.phones) === null || _g === void 0 ? void 0 : _g[0].phoneNumberFull);
    }
    if (options === null || options === void 0 ? void 0 : options.withName) {
        parts.push(fullName);
    }
    if ((options === null || options === void 0 ? void 0 : options.withStatus) && status) {
        switch (status) {
            case ReservationStatus.ACTIVE:
                parts.push('In house');
                break;
            case ReservationStatus.CONFIRMED:
                parts.push("from ".concat(formatFullDMY(convertLocalDateToDate((_h = getCurrentStay(profile)) === null || _h === void 0 ? void 0 : _h.startDay))));
                break;
        }
    }
    if ((options === null || options === void 0 ? void 0 : options.withRate) && rateCode) {
        parts.push(rateCode);
    }
    return parts.join(' | ');
};
export var birthdayToAge = function (birthday) {
    if (!birthday)
        return 0;
    var today = new Date();
    var birthDate = new Date(birthday);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
};
export var extractInitials = function (name) {
    if (!name)
        return '';
    // Split by any non-letter character
    var words = name.trim().split(/[^a-zA-Z]+/).filter(Boolean);
    if (words.length === 0)
        return '';
    if (words.length === 1)
        return words[0][0].toUpperCase();
    return (words[0][0] + words[1][0]).toUpperCase();
};
export var findProfileById = function (profiles, id) {
    if (!id)
        return undefined;
    return profiles.find(function (p) { var _a; return p.id === id || ((_a = p.mergedChildrenIds) === null || _a === void 0 ? void 0 : _a.includes(id)); });
};
export var filterProfilesByIds = function (profiles, ids) {
    if (!(ids === null || ids === void 0 ? void 0 : ids.length))
        return [];
    return profiles.filter(function (p) {
        var _a;
        return ids.includes(p.id) ||
            ((_a = p.mergedChildrenIds) === null || _a === void 0 ? void 0 : _a.some(function (childId) { return ids.includes(childId); }));
    });
};
export var onlyCrqlarV2External = function (profile) {
    var _a, _b;
    // These represent the allowed connectors for the profile to be editable
    var allowedConnectors = ['crqlarV2', 'maileon'];
    // If more than > 2, return false
    if (((_a = profile === null || profile === void 0 ? void 0 : profile.externalInfo) === null || _a === void 0 ? void 0 : _a.length) > allowedConnectors.length)
        return false;
    if ((_b = profile === null || profile === void 0 ? void 0 : profile.externalInfo) === null || _b === void 0 ? void 0 : _b.length) {
        for (var _i = 0, _c = profile.externalInfo; _i < _c.length; _i++) {
            var extInfo = _c[_i];
            if (!allowedConnectors.includes(extInfo.provider)) {
                // If there is any provider outside of allowed connectors, return false
                return false;
            }
        }
    }
    return (profile === null || profile === void 0 ? void 0 : profile.primaryProvider) === 'crqlarV2';
};
// Groups of three, with a lone trailing digit folded into the last group: "664 123 4567", not "664 123 456 7".
var groupDigits = function (digits) {
    var _a;
    var groups = (_a = digits.match(/.{1,3}/g)) !== null && _a !== void 0 ? _a : [];
    if (groups.length > 1 && groups[groups.length - 1].length === 1) {
        var last = groups.pop();
        groups[groups.length - 1] += last;
    }
    return groups.join(' ');
};
/**
 * Display form of a stored phone number: "+43 664 123 4567". Uses the country's own grouping when the
 * phone library knows it and the digit count fits, else groups of three. Numbers without an international
 * prefix cannot be placed in a country, so they come back as stored.
 */
export var formatPhoneForDisplay = function (raw) {
    var _a, _b;
    var trimmed = (_a = raw === null || raw === void 0 ? void 0 : raw.trim()) !== null && _a !== void 0 ? _a : '';
    var international = trimmed.startsWith('+') || trimmed.startsWith('00');
    var digits = trimmed.replace(/\D/g, '').replace(/^00/, '');
    if (!international || !digits)
        return trimmed;
    var phone = "+".concat(digits);
    var _c = guessCountryByPartialPhoneNumber({ phone: phone, countries: defaultCountries }), country = _c.country, fullDialCodeMatch = _c.fullDialCodeMatch;
    if (!country || !fullDialCodeMatch)
        return trimmed;
    var national = digits.slice(country.dialCode.length);
    var mask = getActiveFormattingMask({ phone: phone, country: country, defaultMask: '' });
    var maskDigits = ((_b = mask.match(/\./g)) !== null && _b !== void 0 ? _b : []).length;
    if (!mask || maskDigits !== national.length) {
        return "+".concat(country.dialCode, " ").concat(groupDigits(national)).trim();
    }
    var index = 0;
    var formatted = mask.replace(/\./g, function () { return national[index++]; });
    return "+".concat(country.dialCode, " ").concat(formatted);
};
